import axios from 'axios';
import log from '../../../logger';

/**
 * CSV import. Replaces the data half of Angular's `importService`.
 *
 * `ng-file-upload` is gone; this is a plain `FormData` post, which is what `Upload.upload`
 * built underneath. The two parts keep their names, `importData` and `data`, because the
 * server reads them by name (`/import-api/importRecords`).
 *
 * Note `req.files` is always set to `{}` by multer on a multipart request, so the server
 * checks the named part rather than the object. That is why the file part must still be
 * called `importData` and must still be named `importFile.csv`.
 */
export async function importRecords(file, importType, importParams, onProgress) {
  const form = new FormData();
  form.append('importData', file, 'importFile.csv');
  form.append('data', JSON.stringify({ importType, importParams }));
  try {
    const { data } = await axios.post('/import-api/importRecords', form, {
      onUploadProgress: (event) => {
        if (!onProgress || !event.total) return;
        onProgress(Math.round((100 * event.loaded) / event.total));
      },
    });
    return { success: true, importStatus: data.importStatus };
  } catch (error) {
    log.debug('Import failed', error);
    // Resolves rather than throws, as the Angular version did: the dialog shows the message
    // and stays open so the admin can pick a different file.
    return { success: false, error: 'Failed to import data.' };
  }
}

export async function getImportStatus(importId) {
  const { data } = await axios.get('/import-api/getImportStatus', { params: { importId } });
  return data.importStatus;
}

export async function getErrorLog(importId) {
  const { data } = await axios.get('/import-api/exportImportErrors', { params: { importId } });
  return data.errorsUrl;
}
